import PropTypes from 'prop-types';
import React, { useRef } from 'react';

import useScrollToElement from '../../hooks/useScrollToElement';

const ScrollIntoView = ({ children, ...parentProps }) => {
  const hasChildren = React.Children.count(children) > 0;
  const toCenter = hasChildren;
  const ref = useRef();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useScrollToElement(ref, toCenter);

  if (!hasChildren) {
    return <span ref={ref} />;
  }

  return React.Children.map(children, (child, index) => {
    // If one or multiple children are being rendered, scroll to the first one
    if (index === 0) {
      // ref needs to be forwarded to be able to pass the prop to the cloned element
      return React.cloneElement(child, {
        ref,
        // eslint-disable-next-line react/no-array-index-key
        key: `el-${index}`,
        ...parentProps,
      });
    }

    return child;
  });
};

ScrollIntoView.propTypes = {
  children: PropTypes.node,
};

ScrollIntoView.defaultProps = {
  children: null,
};

export default ScrollIntoView;
